export default {
  'terms.title': 'Conditions d\'utilisation',
  'terms.subtitle': 'Veuillez lire attentivement nos termes et conditions.',
  'terms.last_updated': 'Dernière mise à jour',
  'terms.introduction.title': 'Introduction',
  'terms.introduction.content': 'Bienvenue sur Pink Paradise... En accédant ou en utilisant notre service, vous acceptez d\'être lié par ces termes...',
  
  'privacy.title': 'Politique de confidentialité',
  'privacy.subtitle': 'Comment nous collectons, utilisons et protégeons vos données.',
  'privacy.last_updated': 'Dernière mise à jour',
  'privacy.introduction.title': 'Introduction',
  'privacy.introduction.content': 'Votre vie privée est importante pour nous. Cette politique explique quelles informations personnelles nous collectons...',
  
  'cookies.title': 'Politique relative aux cookies',
  'cookies.subtitle': 'Comment nous utilisons les cookies sur notre plateforme.',
  'cookies.last_updated': 'Dernière mise à jour',
  'cookies.introduction.title': 'Introduction',
  'cookies.introduction.content': 'Nous utilisons des cookies pour améliorer votre expérience sur notre site...',
  
  'content_policy.title': 'Politique de contenu',
  'content_policy.subtitle': 'Nos règles concernant le contenu publié sur la plateforme.',
  'content_policy.last_updated': 'Dernière mise à jour',
  'content_policy.introduction.title': 'Introduction',
  'content_policy.introduction.content': 'Cette politique décrit les types de contenu autorisés et interdits sur Pink Paradise...',
  
  'about.title': 'À Propos de Nous',
  'about.subtitle': 'En savoir plus sur Pink Paradise.',
  'about.mission_title': 'Notre Mission',
  'about.mission_content': 'Chez Pink Paradise, nous nous engageons à créer un environnement sûr, discret et premium où les adultes peuvent se connecter pour des relations mutuellement bénéfiques.',
  'about.why_choose': 'Pourquoi Choisir Pink Paradise',
  'about.safety_first': 'La Sécurité d\'Abord',
  'about.quality_selection': 'Sélection de Qualité',
  'about.discreet_service': 'Service Discret',
  'about.support': 'Support 24/7',
  
  'how_it_works.title': 'Comment Ça Marche',
  'how_it_works.subtitle': 'Une plateforme sécurisée et discrète qui connecte les clients avec des escorts vérifiés pour des expériences authentiques.',
  'how_it_works.for_clients': 'Pour les Clients',
  'how_it_works.for_escorts': 'Pour les Escorts',
  'how_it_works.secure_private': 'Sécurisé et Privé',
  'how_it_works.verified_profiles': 'Profils Vérifiés',
  'how_it_works.secure_payments': 'Paiements Sécurisés',
  
  'blog.title': 'Blog',
  'blog.subtitle': 'Insights, conseils et histoires de notre communauté et experts pour vous aider à naviguer dans le monde des connexions en ligne.',
  'blog.read_article': 'Lire l\'Article',
  'blog.load_more': 'Charger Plus d\'Articles',
  
  'faq.title': 'Foire Aux Questions',
  'faq.subtitle': 'Trouvez des réponses aux questions les plus courantes sur notre plateforme et nos services.',
  'faq.search_placeholder': 'Rechercher des réponses...',
  'faq.search_button': 'Rechercher',
  'faq.still_questions': 'Vous avez encore des questions ?',
  'faq.contact_support': 'Vous ne trouvez pas la réponse que vous cherchez ? Veuillez contacter notre équipe de support.',
  'faq.contact_button': 'Contacter le Support',
  
  'safety_tips.title': 'Conseils de Sécurité',
  'safety_tips.subtitle': 'Protégez-vous lors de l\'utilisation de notre plateforme avec ces conseils de sécurité essentiels.',
  
  'security.title': 'Sécurité',
  'security.subtitle': 'Comment nous protégeons vos informations et maintenons votre sécurité sur notre plateforme.',
  
  'support.title': 'Support',
  'support.subtitle': 'Nous sommes là pour vous aider. Contactez notre équipe de support pour toute question ou assistance.',
  'support.contact_us': 'Contactez-nous',
  'support.form.name': 'Votre Nom',
  'support.form.email': 'Votre Email',
  'support.form.subject': 'Sujet',
  'support.form.message': 'Message',
  'support.form.submit': 'Envoyer le Message'
};
